import col from './col.vue'

col.install = function(Vue) {
  Vue.component(col.name, col)
}

export default col
